import React from 'react';

import FileItem from './FileItem';
import type {
    UploadFile,
    UploadChangeEvent,
} from '../Upload/core/ImplicitFileInput';
import './FilesList.css';

interface FilesListProps {
    files?: UploadFile[];
    className?: string;
    onRemove?: (info: UploadChangeEvent) => void;
}

const FilesList: React.FC<FilesListProps> = ({
    files = [],
    className = '',
    onRemove = () => {},
}) => {
    const handleDelete = (removedFile: UploadFile) => {
        const newFileList = files.filter(
            (file) => file.uid !== removedFile.uid
        );

        onRemove({
            file: removedFile,
            fileList: newFileList,
        });
    };

    return (
        <div className={`FilesList ${className}`}>
            {files.length > 0 && (
                <div className="upload-list">
                    {files.map((file) => (
                        <FileItem
                            key={file.uid}
                            onDelete={() =>
                                handleDelete(file)
                            }
                        >
                            {file.name}
                        </FileItem>
                    ))}
                </div>
            )}
        </div>
    );
};

export default FilesList;
